import { SignalDoc, SignalType } from "@megaron/docs-contracts";

const persistentSignalTypes: ReadonlySet<string> = new Set<SignalType>([
  "regionCustomerMissingPhone",
  "posCustomerMissingGooglePlaceId",
  "regionCustomerMissingEmail",
  "draftInvoice",
  "loyaltyAdminOrderCreated",
]);

export const isPersistentSignal = (signal: SignalDoc): boolean => persistentSignalTypes.has(signal.signalType);

export const isSignalUnread = (signal: SignalDoc): boolean => !signal.isRead || isPersistentSignal(signal);
